// Saved filter sets: a viewer's favourite filter combinations for a dashboard (and tab).
// Signed-in users keep them on the server; anonymous public viewers keep them in the browser.
import api from "@/lib/api";

const LS_KEY = (dashboardId) => `eip_filter_sets_${dashboardId}`;

function readLocal(dashboardId) {
  try { return JSON.parse(localStorage.getItem(LS_KEY(dashboardId)) || "[]"); } catch { return []; }
}
function writeLocal(dashboardId, sets) {
  try { localStorage.setItem(LS_KEY(dashboardId), JSON.stringify(sets.slice(0, 40))); } catch { /* quota */ }
}

export function setsForTab(sets = [], tabId = null) {
  return sets.filter((s) => !s.tab_id || !tabId || s.tab_id === tabId);
}

export async function loadFilterSets({ dashboardId, publicToken = null }) {
  if (publicToken) {
    let shared = [];
    try {
      const { data } = await api.get(`/public/dashboard/${publicToken}/filter-sets`);
      shared = (data.sets || []).map((s) => ({ ...s, mine: false }));
    } catch { /* not shared / offline */ }
    return [...shared, ...readLocal(dashboardId || publicToken)];
  }
  if (!dashboardId) return [];
  const { data } = await api.get(`/dashboards/${dashboardId}/filter-sets`);
  return data.sets || [];
}

export async function saveFilterSet({ dashboardId, publicToken = null, name, values, tabId = null, shared = false, isDefault = false }) {
  if (publicToken) {
    const local = readLocal(dashboardId || publicToken);
    const set = { id: `loc_${Date.now()}`, name, values, tab_id: tabId, shared: false, default: false, mine: true, local: true };
    writeLocal(dashboardId || publicToken, [...local, set]);
    return set;
  }
  const { data } = await api.post(`/dashboards/${dashboardId}/filter-sets`, {
    name, values, tab_id: tabId, shared, default: isDefault,
  });
  return data;
}

export async function deleteFilterSet({ dashboardId, publicToken = null, id }) {
  if (publicToken || String(id).startsWith("loc_")) {
    const key = dashboardId || publicToken;
    writeLocal(key, readLocal(key).filter((s) => s.id !== id));
    return;
  }
  await api.delete(`/dashboards/${dashboardId}/filter-sets/${id}`);
}
